import { createReducer } from "redux-create-reducer";
import { confirmValidationFrontToBack } from "./dataConversion";
import { VALIDATION_ACTIONS } from "./validationActions";
import { MISC_VALIDATION_ACTIONS } from "../misc/miscActions";
import { REHYDRATE } from "redux-persist/constants";
import { RegistrationChannel } from "./validationModels";
const VERSION = 2;
const INITIAL_ADD_FORM = {
    referenceNumber: "",
    pin: ""
};
const INITIAL_STATE = {
    version: VERSION,
    isLoading: false,
    error: null,
    confirmation: null,
    authorized: null,
    validationRequest: null,
    decedent: null,
    isSuccess: null,
    fieldErrors: [],
    addForm: INITIAL_ADD_FORM,
    deceased: null,
    tokenLoading: false,
    registerDirectLink: {
        loading: null,
        error: null,
        success: false
    },
    registrationChannel: null
};
/**
 * Reducer creation and export.
 * Uses the constants above to define new state for each action
 */
export default createReducer(INITIAL_STATE, {
    [REHYDRATE](state, action) {
        const { validation } = action.payload;
        if (validation && validation.version === VERSION) {
            return {
                ...validation,
                addForm: state.addForm,
                registerDirectLink: state.registerDirectLink,
                registrationChannel: state.registrationChannel
            };
        }
        return { ...state };
    },
    /* --- Login page, New Account --- */
    [VALIDATION_ACTIONS.VALIDATION_CONFIRM_NEW_STARTED](state, action) {
        return {
            ...state,
            isLoading: true,
            error: null,
            validationRequest: {
                referenceNumber: action.payload.referenceNumber,
                pin: action.payload.pin,
                attestation: false,
                authorizedId: null,
                confirmation: [],
                decedentRelationship: null,
                firstName: "",
                lastName: "",
                emailAddress: ""
            },
            fieldErrors: [],
            registrationChannel: null
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_CONFIRM_NEW_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload,
            validationRequest: null
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_CONFIRM_NEW_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: false,
            fieldErrors: action.payload
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_CONFIRM_NEW_SUCCEEDED_TRUE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: true,
            confirmation: action.payload.confirmation,
            authorized: action.payload.authorized,
            decedent: action.payload.decedent,
            deceased: action.payload.deceased,
            registrationChannel: RegistrationChannel.LoginPage
        };
    },
    [VALIDATION_ACTIONS.SIGNUP_DIRECT_LINK_STARTED](state, _action) {
        return {
            ...state,
            registerDirectLink: {
                loading: true,
                error: null,
                success: false
            },
            isSuccess: null,
            error: null,
            validationRequest: null
        };
    },
    [VALIDATION_ACTIONS.SIGNUP_DIRECT_LINK_FAILED](state, action) {
        return {
            ...state,
            registerDirectLink: {
                loading: false,
                error: action.payload.error,
                success: false
            },
            isSuccess: null,
            error: null,
            validationRequest: null
        };
    },
    [VALIDATION_ACTIONS.SIGNUP_DIRECT_LINK_SUCCEEDED](state, action) {
        const { confirmationRequirements, referenceNumber, pin, channel } = action.payload;
        return {
            ...state,
            registerDirectLink: {
                loading: false,
                error: null,
                success: true
            },
            isSuccess: true,
            error: null,
            validationRequest: {
                referenceNumber,
                pin,
                attestation: false,
                authorizedId: null,
                confirmation: [],
                decedentRelationship: null,
                firstName: "",
                lastName: "",
                emailAddress: ""
            },
            confirmation: confirmationRequirements.confirmation,
            authorized: confirmationRequirements.authorized,
            decedent: confirmationRequirements.decedent,
            deceased: confirmationRequirements.deceased,
            registrationChannel: channel
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_TOKEN_QUICKPAY](state, action) {
        return {
            ...state,
            tokenLoading: action.payload.tokenLoading,
        };
    },
    /* --- New Account Validation --- */
    [VALIDATION_ACTIONS.VALIDATION_NEW_STARTED](state, { payload }) {
        return {
            ...state,
            isLoading: false,
            error: null,
            fieldErrors: [],
            // validation data needs to be formatted before saving to the state. request to API is based on state
            validationRequest: confirmValidationFrontToBack(payload, null)
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_NEW_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_NEW_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: false,
            fieldErrors: action.payload
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_NEW_SUCCEEDED_TRUE](state, _action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: true
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_SET_AUTHORIZED_ID_NEW](state, action) {
        if (state.validationRequest == null) {
            throw new Error("Unexpected state");
        }
        return {
            ...state,
            validationRequest: {
                ...state.validationRequest,
                authorizedId: action.payload === -1 ? null : action.payload
            }
        };
    },
    /* --- Dashboard, Add Account --- */
    [VALIDATION_ACTIONS.VALIDATION_CONFIRM_ADD_STARTED](state, action) {
        return {
            ...state,
            isLoading: true,
            error: null,
            fieldErrors: [],
            validationRequest: {
                referenceNumber: parseInt(action.payload.referenceNumber, 10),
                pin: parseInt(action.payload.pin, 10),
                attestation: false,
                authorizedId: null,
                confirmation: [],
                decedentRelationship: null,
                firstName: "",
                lastName: "",
                emailAddress: ""
            },
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_CONFIRM_ADD_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_CONFIRM_ADD_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: false,
            fieldErrors: action.payload
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_CONFIRM_ADD_SUCCEEDED_TRUE](state, action) {
        return {
            ...state,
            isLoading: false,
            confirmation: action.payload.confirmation,
            authorized: action.payload.authorized,
            deceased: action.payload.deceased,
            isSuccess: null // Don't show success message yet
        };
    },
    /* --- Add Account Validation from Dashboard Modal  --- */
    [VALIDATION_ACTIONS.VALIDATION_ADD_STARTED](state, { payload }) {
        return {
            ...state,
            isLoading: false,
            error: null,
            fieldErrors: [],
            // validation data needs to be formatted before saving to the state. request to API is based on state
            validationRequest: confirmValidationFrontToBack(payload, payload.authorizedId)
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_ADD_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload,
            validationRequest: null
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_ADD_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: false,
            fieldErrors: action.payload
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_ADD_SUCCEEDED_TRUE](state, _action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: true,
            addForm: INITIAL_ADD_FORM
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_SET_AUTHORIZED_ID_ADD](state, action) {
        if (state.validationRequest == null) {
            throw new Error("Unexpected state");
        }
        return {
            ...state,
            validationRequest: {
                ...state.validationRequest,
                authorizedId: action.payload === -1 ? null : action.payload
            }
        };
    },
    [VALIDATION_ACTIONS.VALIDATION_ADD_FORM_CHANGE](state, { payload }) {
        return {
            ...state,
            addForm: payload
        };
    },
    /* --- Reset Status Messages --- */
    [MISC_VALIDATION_ACTIONS.RESET_MESSAGES](state, _action) {
        return {
            ...state,
            error: null,
            isSuccess: null,
            isLoading: false,
            fieldErrors: []
        };
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/validation/validationReducer.ts